// lang-en.ts

export const LANG_ML_NAME = 'ml';

export const LANG_ML_TRANS = {
    'Voucher Report':'വൗച്ചർ റിപ്പോർട്ട്',
    'Date Configuration':'ഡേറ്റ്  കോൺഫിഗുറേഷൻ',
    'Vihitham Amount':'വിഹിതം തുക',
    'Advance Amount':'അഡ്വാൻസ് തുക',
    'Payment Date':'പേയ്മെന്റ്  തീയതി',
    'Advance Date':'അഡ്വാൻസ് തീയതി',
    'Group Pooja':'ഗ്രൂപ്പ് പൂജ',
    'Sale Summary':'വില്‍പന സംഗ്രഹം',
    'Group':'ഗ്രൂപ്പ്',
    'Supplier wise Register':'വിൽപ്പനക്കാർ രജിസ്റ്റർ',
    'Supplier List':'വിൽപ്പനക്കാർ ലിസ്റ്റ്',
    'Stock Statement':'സ്റ്റോക്ക് സ്റ്റേററ്മെൻറ്',
    'Purchase Register':'വാങ്ങൽ രജിസ്റ്റർ',
    'Issue Details':'വിതരണവിവരം',
    'Collection Summary':'കളക്ഷൻ സംഗ്രഹം',
    'Material Refund':'സാധനം തിരിച്ചടയ്‌ക്കല്‍',
    'Full':'ഫുൾ',
    'Cash Book Revised':'പുതുക്കിയ ക്യാഷ്ബുക്ക്',
    'Manual Entry Report':'മാനുവൽ എൻട്രി',
    'Pooja Bookings Revised':'നടത്തേണ്ട പൂജകൾ (R)',
    'Pooja Collection':'പൂജ കളക്ഷൻ',
    'Pooja Collection - V2':'പൂജ കളക്ഷൻ - V2',
    'Online Collection':'ഓൺലൈൻ കളക്ഷൻ',
    'Family':'ഫാമിലി',
    'User Name': 'യൂസർ',
    'Username': 'യൂസർ',
    'User': 'യൂസർ',
    'Last Name': 'ലാസ്റ്റ് പേര്',
    'ID': 'ഐഡി',
    'DOB': 'ജനനം',
    'Today Stock':'ഇന്നത്തെ സ്റ്റോക്ക്',
    'Designation': 'പദവി',
    'Add Phone Number':' ഫോൺ നമ്പർ ചേർക്കുക',
    'Phone Number':'ഫോൺ നമ്പർ',
    'All Users': 'എല്ലാ യൂസറും',
    'Password': 'പാസ്സ്‌വേർഡ്',
    'LOG IN': 'ലോഗ് ഇൻ',
    'Role': 'യൂസർ തരം',
    'Vazipadu': 'വഴിപാട്',
    'Vazhipadu': 'വഴിപാട്',
    'Pooja': 'വഴിപാട്',
    'Deity': 'പ്രതിഷ്‌ഠ',
    'Avakasi':'അവകാശി',
    'Vihitham':'വിഹിതം',
    'Category': 'കാറ്റഗറി',
    'Code': 'കോഡ്',
    'Description': 'വിവരണം',
    'Properties': 'പ്രത്യേകത',
    'Name': 'പേര്',
    'HOME': 'ഹോം',
    'Update Stock': 'സ്റ്റോക്ക് പുതുക്കുക',
    'Administration': 'അഡ്മിനിസ്ട്രേഷൻ',
    'Account': 'അക്കൗണ്ട്',
    'Head': 'ഹെഡ്',
    'Qty': 'അളവ് ',
    'Manglish Layouts':'മംഗ്ലീഷ് രൂപരേഖ',
    'Licence':'ലൈസൻസ്',
    'About':'ഞങ്ങളെപ്പറ്റി',
    'Edit':'പുതുക്കുക',
    'Income Report':'വരവ് റിപ്പോർട്ട്',
    'Auditorium Enquiry Edit': 'ഓഡിറ്റോറിയം അന്വേഷണം പുതുക്കുക',
    'Auditorium Enquiry View': 'ഓഡിറ്റോറിയം അന്വേഷണം കാണുക',
    'Personal Id Pooja Report': 'പേർസണൽ ഐഡി പൂജ റിപ്പോർട്ട്',
    'Registered Devotee Pooja Report': 'രജിസ്റ്റർ ഭക്തൻ പൂജ',
    'Add Personal Devotee': 'പേർസണൽ ഭക്തൻ ചേർക്കുക',
    'Add Devotee': 'ഭക്തൻ ചേർക്കുക',
    'Personal': 'വ്യക്തിപരമായ',
    'Account Head': 'അക്കൗണ്ട് ഹെഡ്',
    'Access Rights': 'പ്രവേശനാവകാശം',
    'Cheque Enquiry': 'ചെക്ക് അന്വേഷണം',
    'Add User': 'യൂസർ എഡിറ്റ് ',
    'Account Balance': 'അക്കൗണ്ട് ബാലൻസ്',
    'Vazhipadu Head': 'വഴിപാട് ഹെഡ്',
    'Vendor / Customer': 'വിൽപ്പനക്കാർ/കസ്റ്റമർ',
    'Vendor': 'വിൽപ്പനക്കാർ',
    'Auto Back Up':'ഓട്ടോ ബാക്കപ്പ്',
    'Customer': 'കസ്റ്റമർ',
    'Avakasi Vihitham':'അവകാശി വിഹിതം',
    'Employees': 'ജീവനക്കാർ',
    'Employee': 'ജീവനക്കാരൻ',
    'Product': 'ഉൽപ്പന്നം',
    'Per Pooja Items Report':'പെർ പൂജ ഐറ്റംസ്‌ റിപ്പോർട്ട്',
    'Per Pooja Items':'പെർ പൂജ ഐറ്റംസ്‌',
    'Products': 'ഉൽപ്പന്നം',
    'Vazhipad': 'വഴിപാട്',
    'Expense': 'ചെലവ്',
    'Detailed': 'വിശദമായ',
    'No data available': 'വിവരങ്ങൾ ലഭ്യമല്ല',
    'Statement': 'സ്റ്റേറ്റ് മെൻറ്',
    'Bank': 'ബാങ്ക്',
    'Add': 'ചേർക്കുക',
    'Nadavaravu': 'നടവരവ്',
    'Store Transfer': 'സ്റ്റോർ ട്രാൻസ്‌ഫർ',
    'Transfer': 'ട്രാൻസ്‌ഫർ',
    'List': 'പട്ടിക',
    'Pass': 'പാസ്',
    'Member': 'മെമ്പർ',
    'Member Heads':'മെമ്പർ ഹെഡ്',
    'Members': 'മെമ്പർ പട്ടിക',
    'Membership': 'മെമ്പർഷിപ്പ്',
    'Add Member': 'മെമ്പർ ചേർക്കുക',
    'Pending': 'പെൻ്റിംഗ് ',
    'Auditorium': 'ഓഡിറ്റോറിയം',
    'Auditorium Report': 'ഓഡിറ്റോറിയം റിപ്പോർട്ട്',
    'Enquiry': 'അന്വേഷണം',
    // 'Pooja': 'പൂജ',
    'edit product': 'ഉൽപ്പന്നം പുതുക്കുക',
    'add product': 'ഉൽപന്നം ചേർക്കുക',
    'Date Of Birth': 'ജനിച്ച ദിവസം',
    'Pooja Enquiry': 'പൂജാ അന്വേഷണം',
    'Reports': 'റിപ്പോർട്ട്',
    'Audit': 'ആഡിറ്റ്',
    'Pooja Invoices': 'പൂജ ബില്ലുകൾ',
    'Star Wise Pooja Report': 'നക്ഷത്ര പൂജ റിപ്പോർട്ട്',
    'Report': 'റിപ്പോർട്ട്',
    'Bank Statement Report': 'ബാങ്ക് സ്റ്റേറ്റ് മെൻറ് റിപ്പോർട്ട്',
    'Current Stock Report': 'ഇന്നത്തെ സ്റ്റോക്ക്',
    'Membership Report': 'മെമ്പർഷിപ്പ് റിപ്പോർട്ട്',
    'Nadavaravu Report': 'നടവരവ് റിപ്പോർട്ട്',
    'Nadavaravu Report Revised': 'നടവരവ് റിപ്പോർട്ട് (R)',
    'Stock Report': 'സ്റ്റോക്ക് റിപ്പോർട്ട്',
    'POS Report':'പോസ് റിപ്പോർട്ട്',
    'CARD Report':'കാർഡ് റിപ്പോർട്ട്',
    'Stock': 'സ്റ്റോക്ക്',
    'Income & Expense Report': 'വരവ് ചെലവ് റിപ്പോർട്ട്',
    'Income & Expense Report v1': 'വരവ് ചെലവ് റിപ്പോർട്ട് (v1)',
    'Income & Expense Report (R)': 'വരവ് ചെലവ് റിപ്പോർട്ട് (R)',
    'Expense Report': 'ചെലവ് റിപ്പോർട്ട്',
    'Cheque Clearance Report': 'ചെക്ക് ക്ലീറൻസ് റിപ്പോർട്ട്',
    'Cheque Report':'ചെക്ക് റിപ്പോർട്ട്',
    'Payment Payable': 'പേയ്മെൻ്റ് പേയബിൾ',
    'Payment Receivable': 'പേയ്മെൻറ് റീസിവബിൾ',
    'Cancelled Transaction': 'ക്യാൻസലേഷൻ',
    'Income Collection': 'വരവ്‌ കളക്ഷൻ',
    'Collection Report': 'കളക്ഷൻ റിപ്പോർട്ട്',
    'Collection': 'കളക്ഷൻ',
    'Pooja Bookings':'നടത്തേണ്ട പൂജകൾ',
    'Pooja Bookings v1':'നടത്തേണ്ട പൂജകൾ (v1)',
    'Store Pass Report': 'സ്റ്റോർ പാസ് റിപ്പോർട്ട്',
    'Store Pass': 'സ്റ്റോർ പാസ്',
    'Transaction': 'ഇടപാട്',
    'Purpose': 'ആവശ്യകത',
    'Type': 'തരം',
    'Period': 'തവണ',
    'Invoice': 'രസീത്',
    'Bill': 'ബില്ല്',
    'Create Bill': 'ബില്ല് ചെയ്യുക',
    'Create Invoice': 'രസീത് ചെയ്യുക',
    'Invoice Number': 'രസീത്',
    'Invoice At': 'രസീത് തീയതി',
    'Cleared At': 'ചെക്ക് ക്ലീറൻസ് തീയതി',
    'Cheque': 'ചെക്ക്',
    'Cheque No': 'ചെക്ക് നമ്പർ',
    'cash/cheque': 'ക്യാഷ് / ചെക്ക്',
    'cash/cheque/pos':'ക്യാഷ് / ചെക്ക് / പോസ്',
    'Devotee': 'ഭക്തൻ',
    'Star': 'നക്ഷത്രം',
    'Unit': 'യൂണിറ്റ്',
    'Material': 'സാധനം',
    'Pooja Date': 'പൂജ തീയതി',
    'Quantity': 'എണ്ണം',
    'quantity': 'എണ്ണം',
    'Amount': 'തുക',
    'Cost': 'തുക',
    'Paid': 'അടച്ച',
    'Paid Amount': 'കൊടുത്തത്',
    'Received Amount': 'ലഭിച്ചത്',
    'Received': 'ലഭിച്ചത്',
    'Received Item': 'ലഭിച്ച ഐറ്റം',
    'Received Store': 'ലഭിച്ച സ്റ്റോർ',
    'Received Qty': 'ലഭിച്ച അളവ്',
    'Due': 'അടക്കേണ്ട',
    'Due Amount': 'കൊടുക്കേണ്ടത്',
    'Total': 'ആകെ',
    'Devotee name': 'ഭക്തൻ്റെ പേര്',
    'Devotee Name': 'ഭക്തൻ്റെ പേര്',
    'Collecting Person': 'വ്യക്തി',
    'Opening': 'മുന്നിരിപ്പ്',
    'Incoming': 'വന്നത്',
    'Outgoing': 'പോയത്',
    'Closing': 'നീക്കിയിരിപ്പ്',
    'is required': 'ആവശ്യമാണ്',
    'Date': 'തീയതി',
    'diety': 'പ്രതിഷ്ഠ',
    'Diety': 'പ്രതിഷ്ഠ',
    'Prathishta': 'പ്രതിഷ്ഠ',
    'Choose Star': 'നക്ഷത്രം',
    'Choose Vazipadu': 'പൂജ തിരഞ്ഞെടുക്കുക',
    'name': 'പേര്',
    'Invalid': 'അസാധു',
    'Address': 'മേൽവിലാസം',
    'Email': 'ഇമെയിൽ',
    'Advance': 'മുൻ‌കൂർ',
    'Balance': 'ബാക്കി',
    'Phone': 'ഫോൺ',
    'phone': 'ഫോൺ',
    'Submit': 'സബ്മിറ്റ്',
    'submit': 'സബ്മിറ്റ്',
    'Remove': 'നശിപ്പിക്കുക',
    'Both': 'രണ്ടും',
    'Trancastion': 'ഇടപാട്',
    'type': 'ഇനം',
    'CASH': 'ക്യാഷ്',
    'CHEQUE': 'ചെക്ക്',
    'Status': 'അവസ്ഥ',
    'Continuous Booking': 'തുടർച്ചാ ബുക്കിംഗ്',
    'Booking': 'ബുക്കിംഗ്',
    'days': 'ദിവസങ്ങൾ',
    'Available': 'ലഭ്യമായ',
    'From Date': 'തീയതി മുതൽ',
    'To Date': 'വരെ',
    'must be greater than From Date': 'തീയതി മുതലിനേക്കാൾ മുന്നിലായിരിക്കണം',
    'must be lesser than To Date': 'തീയതി വരെയിനേക്കാൾ പിന്നിലായിരിക്കണം',
    'Selected days': 'തിരഞ്ഞെടുത്ത ദിവസങ്ങളുടെ എണ്ണം',
    'All': 'എല്ലാ',
    'Month': 'മാസം',
    'Monthly Pooja':'മാസപൂജ',
    'Thithi': 'തിഥി',
    'Week': 'ആഴ്ച',
    'Cancel': 'ക്യാൻസൽ',
    'cancel': 'ക്യാൻസൽ',
    'number': 'നമ്പർ',
    'Number': 'നമ്പർ',
    'No:': 'നമ്പർ:',
    'Billed Person Name': 'ബില്ല് ചെയ്ത വ്യക്തി',
    'Book': 'ബുക്ക്',
    'Billing Devotee': 'ബില്ല് ചെയ്ത ഭക്തൻ',
    'Billing': 'ബില്ലിംഗ്',
    'Issued Store': 'ഐറ്റം സ്റ്റോർ',
    'Choose Store': 'സ്റ്റോർ തിരഞ്ഞെടുക്കുക',
    'Store': 'സ്റ്റോർ',
    'No Store': 'സ്റ്റോറില്ല',
    'Personal Pooja': 'പേർസണൽ പൂജ',
    'SAMARPANAM': 'സമർപ്പണം',
    'Samarpanam': 'സമർപ്പണം',
    'NADAVARAVU': 'നടവരവ്',
    'Pooja Stall': 'പൂജാസ്റ്റാൾ',
    'Pooja Booking': 'പൂജാ ബുക്കിങ്',
    'STOCK REDUCING': 'സ്റ്റോക്ക് കുറയ്ക്കൽ',
    'Saleable': 'വിൽപ്പന',
    'Rate': 'നിരക്ക്',
    'Choose Item': 'ഐറ്റം തിരഞ്ഞെടുക്കുക',
    'Issued Item': 'വിതരണ ഐറ്റം',
    'Issued Qty': 'വിതരണ അളവ്',
    'Item': 'ഐറ്റം',
    'Issued': 'ഉല്പാദിപ്പിച്ച',
    'Entered quantity is out off current quantity': 'നിർദിഷ്‌ട അളവ് സ്റ്റോക്കിലില്ല',
    'Recieved': 'സ്വീകരിക്കപ്പെട്ട',
    'Please choose any one of the above item': 'ഏതെങ്കിലും ഐറ്റം തിരഞ്ഞെടുക്കുക',
    // 'Add': 'ആഡ്',
    'Thulabharam': 'തുലാഭാരം',
    'You can\'t book this pooja for today': 'ഇന്ന് ഈ പൂജ ബുക്ക് ചെയ്യാൻ സാധ്യമല്ല',
    'You can\'t book this pooja for tomorrow': 'നാളെ ഈ പൂജ ബുക്ക് ചെയ്യാൻ സാധ്യമല്ല',
    'Warning': 'മുന്നറിയിപ്പ്',
    'Please change booking date': 'വേറെ ബുക്കിങ് തിയ്യതി തിരഞ്ഞെടുക്കൂ',
    'Limit exceeded': 'പരിധി കഴിഞ്ഞിരിക്കുന്നു',
    'Anyway': 'ഏതെങ്കിലും വിധത്തിൽ',
    'continue?': 'തുടരണോ?',
    'No stock available': 'സ്റ്റോക്കില്ല',
    'Limit exceeded to book this pooja': 'ഈ പൂജയ്ക്  ഉള്ള പരിധി കഴിഞ്ഞിരിക്കുന്നു',
    'Can add multiple devotees': 'ഒന്നിലധികം ഭക്തരെ ചേർക്കാൻ കഴിയും',
    'Print': 'പ്രിൻ്റ്',
    'Salary': 'ശമ്പളം',
    'Booking on': 'ബുക്കിംഗ് തീയതി',
    'Timing': 'സമയക്രമം',
    'Forenoon': 'രാവിലെ',
    'Afternoon': 'ഉച്ചകഴിഞ്ഞു',
    'Full Day': 'മുഴുവൻ ദിവസവും',
    'Temple': 'ക്ഷേത്രം',
    'Postage': 'തപാൽ',
    'Confirm your postage address': 'നിങ്ങളുടെ തപാൽ വിലാസം സ്ഥിരീകരിക്കണോ',
    'Same for all devotee': 'എല്ലാ ഭക്തർക്കും ഇത് തന്നെ',
    'Add devotee address': 'ഭക്തന്റെ വിലാസം ചേർക്കുക',
    'Edit devotee address': 'ഭക്തന്റെ വിലാസം എഡിറ്റുചെയ്യുക',
    'Logo': 'ലോഗോ',
    'Counter': 'കൗണ്ടർ',
    'Receipt': 'രസീത്',
    'Rows': 'വരി',
    'Keyboard': 'കീബോർഡ്',
    'License Expiry': 'കാലാവധി',
    'Financial Year': 'സാമ്പത്തിക വർഷം',
    'Basic': 'അടിസ്ഥാന',
    'Advanced': 'ഉന്നത',
    'Settings': 'സജ്ജീകരണങ്ങൾ',
    'Printer': 'പ്രിൻറർ',
    'Action': 'പ്രവൃത്തി',
    'Payment': 'പേമെൻറ്',
    'Create Payment': 'പേമെൻറ് ചെയ്യുക',
    'Method': 'രീതി',
    'Template': 'രൂപരേഖ',
    'Old': 'പഴയ',
    'New': 'പുതിയ',
    'Change': 'മാറ്റുക',
    'Change Password': 'പാസ്സ്‌വേർഡ് മാറ്റുക',
    'Is Metal': 'ലോഹമാണോ',
    'Metal': 'ലോഹം',
    'Default': 'മൂല',
    'Booked On': 'ബുക്ക് ചെയ്ത തീയതി',
    'Time': 'സമയം',
    'Income': 'വരവ്‌',
    'General Ledger': 'ജനറൽ ലെഡ്ജർ',
    'Help': 'സഹായി',
    'Welcome': 'സ്വാഗതം',
    'STODA Editor': 'സ്റ്റോട എഡിറ്റർ',
    'Manual Backup': 'മാന്വൽ ബാക്കപ്പ്',
    'Documentation': 'ഡോക്യുമെന്റേഷൻ',
    'Keyboard Shortcuts': 'കീബോർഡ് കുറുക്കുവഴികൾ',
    'View License': 'ലൈസൻസ് കാണുക',
    'Feature Request': 'ഫീച്ചർ അഭ്യർത്ഥന',
    'Report Issue': 'പ്രശ്നം റിപ്പോർട്ട് ചെയ്യുക',
    'Privacy Statement': 'സ്വകാര്യത പ്രസ്താവന',
    'Install Update': 'അപ്ഡേറ്റ് ഇൻസ്റ്റാൾ ചെയ്യുക',
    'Privileges': 'അധികാരങ്ങൾ',
    'Packaged Pooja': 'പാക്കേജുചെയ്ത പൂജ',
    'Add New ': 'പുതിയത് ചേർക്കുക',
    'Add Packaged Pooja': 'പാക്കേജുചെയ്ത പൂജ ചേർക്കുക',
    'Edit Packaged Pooja': 'പാക്കേജുചെയ്ത പൂജ എഡിറ്റുചെയ്യുക',
    'Save': 'സേവ്',
    'Update': 'അപ്ഡേറ്റ്',
    'Number Of Devotees': 'ഭക്തരുടെ എണ്ണം',
    'Exclude Today': 'ഇന്ന് ഒഴിവാക്കുക',
    'Number Of Days': 'ദിവസങ്ങളുടെ എണ്ണം',
    'Choose Thithi': 'തിഥി',
    'Invoice Total': 'മൊത്തം ഇൻവോയ്‌സ്‌',
    'Invoice Received [Cash]': 'ക്യാഷ് ആയി കിട്ടിയത്',
    'Invoice Received [Bank]': 'ബാങ്കിൽ വന്നത്',
    'Receivable Invoice': 'ഇൻവോയ്‌സ്‌ പ്രകാരം കിട്ടാനുള്ളത്',
    'Old Invoice Received [Cash]': 'മുൻ ബാലൻസ് ക്യാഷ് ആയി കിട്ടിയത്',
    'Old Invoice Received [Bank]': 'മുൻ ബാലൻസ് ബാങ്കിൽ വന്നത്',
    'Old Receivable Invoice': 'മുൻ ബാലൻസ് കിട്ടാനുള്ളത്',
    'Total Receivable': 'മുൻ ബാലൻസ്  ചേർത്ത് കിട്ടാനുള്ളത്',
    'Direct Withdrawal': 'ബാങ്കിൽ നിന്നും പിൻവലിച്ചത്',
    'Bill Total': 'മൊത്തം ബിൽ',
    'Bill Paid [Cash]': 'ക്യാഷ് ആയി കൊടുത്തത്',
    'Bill Paid [Bank]': 'ബാങ്ക് വഴി കൊടുത്തത്',
    'Payable Bills': 'ബിൽ പ്രകാരം കൊടുക്കാനുള്ളത്',
    'Old Bill Total': 'പഴയ മൊത്തം ബിൽ',
    'Old Bill Paid [Cash]': 'മുൻ ബാലൻസ് ക്യാഷ് ആയി കൊടുത്തത്',
    'Old Bill Paid [Bank]': 'മുൻ ബാലൻസ് ബാങ്ക് വഴി  കൊടുത്തത്',
    'Old Payable Bills': 'മുൻ ബാലൻസ് കൊടുക്കാനുള്ളത്',
    'Total Payable Bills': 'മുൻ ബാലൻസ് ചേർത്ത്  കൊടുക്കാനുള്ളത്',
    'Direct Deposit': 'ബാങ്കിൽ നിക്ഷേപിച്ചത്',
    'Old Balance': 'പഴയ ബാലൻസ്',
    'Receivable': 'കിട്ടാനുള്ള',
    'Total Paid': 'ആകെ നൽകിയത്',
    'Donation': 'സംഭാവന',
    'Marriage': 'വിവാഹം',
    'Marriage Certificate':'വിവാഹ സർട്ടിഫിക്കറ്റ്',
    'Certificate' : 'സർട്ടിഫിക്കറ്റ്',
    'POS': 'പോസ്',
    'CARD': 'കാർഡ്',
    'Complete Total': 'ആകെ മൊത്തം',
    'Cash': 'ക്യാഷ്',
    'Cash Book': 'ക്യാഷ് ബുക്ക്',
    'Cash Book (R)': 'ക്യാഷ് ബുക്ക് (R)',
    'Purchase Return Report':'പാർച്ചയ്സ് റിട്ടേൺ റിപ്പോർട്ട്',
    'Sales Return Report':'സെയിൽസ്‌ റിട്ടേൺ റിപ്പോർട്ട്',
    'Day Book': 'ദിവസ ബുക്ക്',
    'Consolidated': 'കൺസോളിഡേറ്റഡ്',
    'Agreed':'സമ്മതിച്ച',
    'Mother Name': 'മാതാവിൻ്റെ പേര്',
    'Father Name': 'പിതാവിൻ്റെ പേര്',
    'Marriage Date': 'വിവാഹ തീയതി',
    'Age': 'വയസ്സ്',
    'Sign':'ഒപ്പ്',
    'Secretary':'സെക്രട്ടറി',
    'Place':'സ്ഥലം',
    'Marriage Place':'വിവാഹം നടന്ന സ്ഥലം',
    'The marriage of married couple shows that was done according to Hindu custom.':'ടി ദമ്പതികളുടെ  വിവാഹം ഹിന്ദു ആചാരപ്രകാരം നടന്നിട്ടുള്ളതാണെന്നു  സാക്ഷ്യപ്പെടുത്തുന്നു.',
    'Bride':'വധു',
    'Groom':'വരൻ',
    'Voucher No':'വൗച്ചർ നമ്പർ',
    'Voucher':'വൗച്ചർ',
    'Excess Amount':'അധികമായി കിട്ടിയ തുക',
    'Sale':'വരവ്',
    'Sale Report':'വരവ് റിപ്പോർട്ട്',
    'Sale Head':'വരവ് ഹെഡ്',
    'Booking Only':'ബുക്കിങ് മാത്രം',
    'Show Address':'വിലാസം',
    'Note':'വിവരണം',
    'Limit exceeded to book this Marriage': 'വിവാഹം ബുക്കിങ് പരിധി കഴിഞ്ഞിരിക്കുന്നു',
    'Bride Details' : 'വധുവിൻ്റെ വിവരണം',
    'Groom Details' : 'വരൻ്റെ വിവരണം',
    'Bank Charge' : 'ബാങ്ക് ചാർജ്',
    'Bank Interest' : 'ബാങ്ക് പലിശ',
    'Show Payment Status':'പേയ്മെൻ്റ് അവസ്ഥ',
    'Show Invoice Date':'രസീത് തീയതി',
    'Show Amount':'തുക',
    'Uncleared Amount':'ചെക്ക് ക്ലിയർ ചെയ്യാത്ത തുക',
    'Old Uncleared Amount':'പഴയ ചെക്ക് ക്ലിയർ ചെയ്യാത്ത തുക',
    'Vendor Statement':'വെണ്ടർ സ്റ്റേറ്റ് മെൻറ്',
    'Malayalam' : 'മലയാളം',
    'Booking Person' : 'ബുക്കിംഗ് വ്യക്തി',
    'Payment At':'പേമെൻറ് തീയതി',
    'Receipt & Payment':'രസീത് & പേയ്‌മെന്റ്',
    'Receipt & Payment V2':'രസീത് & പേയ്‌മെന്റ് V2',
    // WS-F phase F3: corrected legacy statements (Expense column, V2-only).
    'Income & Expense (V2)':'വരവ് ചെലവ് (V2)',
    'Receipt & Payment (V2)':'രസീത് & പേയ്‌മെന്റ് (V2)',
    // WS-F phase F4: classified Pooja Collection family (Pooja column, V2-only).
    'Pooja Collection (Classified)':'പൂജ കളക്ഷൻ (തരംതിരിച്ചത്)',
    'Pooja Summary (V2)':'പൂജ സംഗ്രഹം (V2)',
    // WS-F phase F5: classified Pooja Bookings / Invoices (Pooja column, V2-only).
    'Pooja Bookings (Classified)':'നടത്തേണ്ട പൂജകൾ (തരംതിരിച്ചത്)',
    'Pooja Invoices (Classified)':'പൂജ ബില്ലുകൾ (തരംതിരിച്ചത്)',
    // WS-F phase F6a: Expense + Stock movement family (Expense column + Stock submenu, V2-only).
    'Expense Report (V2)':'ചെലവ് റിപ്പോർട്ട് (V2)',
    'Stock Transfer (V2)':'സ്റ്റോക്ക് ട്രാൻസ്ഫർ (V2)',
    'Stock Consumption (V2)':'സ്റ്റോക്ക് ഉപഭോഗം (V2)',
    // WS-F phase F6b: secondary report families (Expense column; Card/Cheque in Audit; V2-only).
    'Nadavaravu (V2)':'നടവരവ് (V2)',
    'Avakasi Vihitham (V2)':'അവകാശി വിഹിതം (V2)',
    'Vendor Statement (V2)':'വെണ്ടർ സ്റ്റേറ്റ്മെൻറ് (V2)',
    'Card / Cheque (V2)':'കാർഡ് / ചെക്ക് (V2)',
    // WS-F phase F6c: Postage (Expense column) + Receivable / Payable (Audit column); V2-only.
    'Postage (V2)':'തപാൽ (V2)',
    'Payment Payable (V2)':'നൽകാനുള്ള തുക (V2)',
    'Payment Receivable (V2)':'ലഭിക്കാനുള്ള തുക (V2)',
    // WS-F phase F6d: Day Book (Audit column); V2-only.
    'Day Book (V2)':'ദിവസ ബുക്ക് (V2)',
    // WS-F phase F6e: Partial Payment + Cancelled Transaction (Audit column),
    // Current Stock (Stock submenu); all V2-only.
    'Partial Payment (V2)':'ഭാഗിക പേയ്‌മെന്റ് (V2)',
    'Cancelled Transaction (V2)':'റദ്ദാക്കിയ ഇടപാട് (V2)',
    'Current Stock (V2)':'നിലവിലെ സ്റ്റോക്ക് (V2)',
    'Attendance':'ഹാജർ',
    'Employee Attendance':'എംപ്ലോയീസ് അറ്റൻഡൻസ്',
    'Attendance Details': 'അറ്റൻഡൻസ് വിശദാംശങ്ങൾ',
    'Partial Payment Cash':'പകുതി അടച്ച തുക',
   'Pooja Summary': 'പൂജ സംഗ്രഹം',
   'Grand Total':'ആകെ തുക',
    'Invoice Amount':'ഇൻവോയ്സ് തുക',
    'Invoice No' :'ഇൻവോയ്സ് നമ്പർ',
    'Attendance Report':'അറ്റൻഡൻസ് റിപ്പോർട്ട്',
    'Add Product':'ഉൽപ്പന്നം',
    'Salary Item':'ശമ്പള ഇനം',
    'Employees Payroll':'ജീവനക്കാർ ശമ്പളം',
    'Base Value' : 'അടിസ്ഥാന മൂല്യം',
    'Asset Number' : 'അസറ്റ് നമ്പർ',
    'Back to Login' : 'ലോഗിനിലേക്ക് മടങ്ങുക',
    'Short Name':'ചുരുക്ക പേര്',
    'District': 'ജില്ല',
    'State' : 'സ്റ്റേറ്റ്',
    'Pincode' : 'പിൻ കോഡ്',
    'SMS Short Code' : 'SMS ഷോർട്ട് കോഡ്',
    'Re-type Password' : 'പാസ്സ്‌വേർഡ് വീണ്ടും ടൈപ്പുചെയ്യുക',
    'Mobile' : 'മൊബൈൽ',
    'Login' : 'ലോഗിൻ',
    'Due Paid Report':'ഡ്യൂ പെയ്ഡ് റിപ്പോർട്ട്',
    'Partial Payment Report':'ഭാഗിക പേയ്മെൻ്റ് റിപ്പോർട്ട്',
    'Authority' : 'അതോറിറ്റി',
    'Registration' : 'രജിസ്ട്രേഷൻ',
    'Sign Up' : 'പുതിയ രജിസ്ട്രേഷൻ',
    'Todays Nivedyam List' : 'ഇന്നത്തെ നിവേദ്യം പട്ടിക',
    'Rental Entry':'വാടക ഇനം എൻട്രി',
    'Rental Given Date':'വാടക നൽകിയ തീയതി',
    'Rental Return Date': 'വാടക റിട്ടേൺ തീയതി',
    'Total Days' : 'ആകെ ദിവസങ്ങൾ',
    'Salary Loan' : 'ശമ്പള വായ്പ',
    'Damage':'കേടുപാട്',
    'Purchase':'വാങ്ങിയവ',
    'Sales':'വിറ്റത്',
    'Total Inwards':'ആകെ വന്നത്',
    'Direct':'ആസ്തി',
    'P.Return':'തിരിച്ചയച്ചത്',
    'Consumed':'ഉപയോഗിച്ചത്',
    'Exclude Refund':'റീഫണ്ട് ഒഴിവാക്കുക',
    'Exclude Repayment':'തിരിച്ചടവ് ഒഴിവാക്കുക',
    'Pooja Category List':'പൂജ കാറ്റഗറി ലിസ്റ്റ്',
    'Online Pooja Enquiry':'ഓൺലൈൻ പൂജ അന്വേഷണം',
    'Devaswom Report':'ദേവസ്വം റിപ്പോർട്ട്',
    'Quantity of items spent':'ചിലവായ സാധനങ്ങളുടെ അളവിനു വിവരം കണക്ക്',
    'Amount of items spent':'ചിലവായ സാധനങ്ങളുടെ സംഖ്യക്ക് വിവരം കണക്ക്',
    'Heir share information':'അവകാശി വിഹിതത്തിനു വിവരം കണക്ക്',
    'Items and heir shares':'സാധനവില, അവകാശി വിവരം കണക്ക്',
    'Capital, Inventory, Heirs, Adjustment, Overall':'മുതൽക്കൂട്ട്, സാധനവില, അവകാശികൾ, അഡ്ജസ്റ്റ് മെൻറ്, ഒട്ടാകെ',
    'Remittance Report':'റെമിറ്റൻസ് റിപ്പോർട്ട്',
    'Heir':'അവകാശി',
    'Remittance':'റെമിറ്റൻസ്',
    'Income Expenditure':'വരവ് ചെലവ് റിപ്പോർട്ട് (v2)',
    'Trial Balance':'ട്രയൽ ബാലൻസ്',
    'Balance Sheet':'ബാലൻസ് ഷീറ്റ്',
    'Journal':'ജേർണൽ',
    'Entry':'എൻട്രി',
    'Issue date':'വിതരണ തീയതി',
    'Issue':'വിതരണം',
    'Journal Entry':'ജേർണൽ എൻട്രി',
    'Nivedyam' : 'നിവേദ്യം',
};
